import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { LoginService } from "../services/login.service";
import { UsersService } from "../../pages/administration/services/users.service";
import { FormsModule } from "@angular/forms";
import { CryptoJsService } from "../../core/services/crypto-js.service";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { NotifierModule, NotifierService } from "angular-notifier";
import { ToastsContainer } from "../../../theme/component/toast/toast-container.component";
import { NoSpaceDirective } from 'src/app/core/directive/no-space.directive';
import { firstValueFrom, map, Observable, tap } from 'rxjs';
import { PlanService } from 'src/app/pages/projects/services/plan.service';
import { ChannelProjectService } from 'src/app/pages/projects/services/channel-project.service';
import { GroupPermissionService } from '../services/groupPermission.service';
import { FeatherModule } from 'angular-feather';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from 'src/app/core/services/utils.service';
import { appVersion } from 'src/app/core/services/app-version';
import { jwtDecode } from 'jwt-decode';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule, CommonModule, NgOptimizedImage, FormsModule, NgxSpinnerModule, NotifierModule, ToastsContainer, NoSpaceDirective,
    FeatherModule
  ],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [LoginService, GroupPermissionService]
})
export class LoginComponent implements OnInit {
  msg = '';
  groupPermissions: any = [];

  loginform = true;
  recoverform = false;
  recuerdame: boolean;
  uname: string = '';
  p: string = '';
  availableModules: any[] = [];
  showPassword = false;
  isLoading = false;
  appVersion = appVersion;


  constructor(private login: LoginService, private routes: Router, private userService: UsersService,
    private readonly localStorage: CryptoJsService, public notifier: NotifierService,
    private _spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private _planService: PlanService,
    private _channelProjectService: ChannelProjectService,
    private _groupPermissionService: GroupPermissionService,
    private modalService: NgbModal,
    private utilsService: UtilsService,

  ) {
    this.recuerdame = this.localStorage.getItem('recuerdame') === true;
    this.uname = this.recuerdame ? (this.localStorage.getItem('uname') || '') : '';
    this.p = this.recuerdame ? (this.localStorage.getItem('p') || '') : '';
  }

  ngOnInit(): void {




    this.route.queryParams.subscribe(params => {
      // Capturar parámetros de la URL
      const usr = params['usr'];
      const pass = params['pass'];
      const dni = params['dni'];
      // Validar que los parámetros existan
      if (!usr || !pass) {
        return;
      }

      try {
        // Decodificar el parámetro "pass"
        const decodedPass = decodeURIComponent(pass);
        // Intentar desencriptar el valor de "pass"
        const decryptedValue = this.localStorage.decryptItem(decodedPass);

        if (!decryptedValue) {
          throw new Error('Error al decodificar el valor.');
        }

        // Guardar los datos desencriptados
        this.localStorage.setItem('uname', usr);
        this.localStorage.setItem('p', decryptedValue);
        this.loadDataUrl(usr, decryptedValue, dni, '');

      } catch (error: any) {
        this.notifier.notify('error', error);
      }
    });
  }


  async loadDataUrl(user: string, pass: string, dni: string | null, modal: any) {
    if (this.isLoading) {
      return;
    }

    const normalizedUser = (user || '').trim();
    const normalizedPass = (pass || '').trim();

    if (!normalizedUser || !normalizedPass) {
      this.notifier.notify('warning', 'Ingrese usuario y clave para continuar.');
      return;
    }

    this.msg = '';
    this.persistRememberCredentials(normalizedUser, normalizedPass);
    this.isLoading = true;
    this._spinner.show();

    try {
      const userToken = await firstValueFrom(this.login.keycloakLogin(normalizedUser, normalizedPass));
      if (!userToken?.access_token) {
        this.notifier.notify('warning', 'No fue posible obtener el token de acceso.');
        return;
      }

      this.localStorage.setItem('token', userToken.access_token);
      this.localStorage.setItem('refresh', userToken.refresh_token);
      this.localStorage.setItem('refresh_token', userToken.refresh_token);

      const tokenClaims = this.decodeAccessToken(userToken.access_token);
      const keycloakUsername = tokenClaims?.preferred_username || normalizedUser;
      const userData = await firstValueFrom(this.userService.getUserToatBackEnd(keycloakUsername));

      if (!userData || userData.length === 0) {
        this.notifier.notify('warning', 'No se encontraron datos del usuario.');
        return;
      }

      const userInfo = this.buildExecutiveInfo(userData[0], tokenClaims, keycloakUsername);
      const userId = userInfo.id || '';
      this.localStorage.setItem('executiveInfo', userInfo);
      this.localStorage.setItem('executiveId', userId);
      this.localStorage.setItem('keycloakUserInfo', tokenClaims);

      if (!userId) {
        this.notifier.notify('warning', 'No fue posible identificar al usuario.');
        return;
      }

      if (dni) {
        await firstValueFrom(this.handleChannelProject(userData));
        const planMembershipData = await firstValueFrom(this.handlePlanMembership(dni, userId));
        const hasMembership = this.handlePlanMembershipResult(planMembershipData);
        if (hasMembership) {
          this.routes.navigate(['/toat/channel'], { replaceUrl: true });
        }
        return;
      }

      this.groupPermissions = await firstValueFrom(
        this._groupPermissionService.getGroupPermissions(userId)
      );

      if (this.groupPermissions.length === 0) {
        this.notifier.notify('warning', 'No tiene asignado MODULOS, contáctese con el administrador del sistema!');
        return;
      }

      const adminModules: any[] = [];
      const salesModules: any[] = [];
      const superAdminModules: any[] = [];

      this.groupPermissions.forEach(project => {
        if (project.permissionLevel === 'admin') {
          adminModules.push({
            ...project,
            nombre: 'ADMINISTRACIÓN',
            icono: 'briefcase'
          });
        }
        if (project.permissionLevel === 'sales') {
          salesModules.push({
            ...project,
            nombre: 'AFILIACIONES',
            icono: 'shopping-cart'
          });
        }
        if (project.permissionLevel === 'admin_menu') {
          superAdminModules.push({ ...project });
        }
      });

      const hasAdmin = adminModules.length > 0;
      const hasSales = salesModules.length > 0;

      if (superAdminModules.length > 0) {
        this.localStorage.setItem('assignedSuperAdmin', superAdminModules[0]);
      }

      if (hasAdmin && hasSales) {
        this.availableModules = [...adminModules, ...salesModules];
        if (modal) {
          this.modalService.open(modal, { centered: true, backdrop: 'static', keyboard: false, windowClass: 'modal-type-window' });
          return;
        }
      }

      if (hasAdmin) {
        this.localStorage.setItem('permissionLevel', 'admin');
        this.localStorage.setItem('assignedProjects', adminModules[0]['projects']);
      } else if (hasSales) {
        this.localStorage.setItem('permissionLevel', 'sales');
        this.localStorage.setItem('assignedProjects', salesModules[0]['projects']);
      } else {
        this.notifier.notify('warning', 'No se encontraron módulos asignados para este usuario.');
        return;
      }

      this.utilsService.setUserPermission(this.groupPermissions);
      const redirectPath = hasAdmin ? '/starter' : '/sales/projects-select';
      this.routes.navigate([redirectPath], { replaceUrl: true });
    } catch (error: any) {
      this.msg = 'Credenciales inválidas o error al iniciar sesión.';
      this.notifier.notify('error', this.msg);
      this.localStorage.removeItem('token');
      this.localStorage.removeItem('refresh');
      this.localStorage.removeItem('refresh_token');
    } finally {
      this.isLoading = false;
      this._spinner.hide();
    }
  }

  navigateToModule(module: any) {
    ////console.log('navigateToModuleule', module);
    this.localStorage.setItem('permissionLevel', module.permissionLevel);
    this.localStorage.setItem('assignedProjects', (module['projects']));
    this.utilsService.setUserPermission(this.groupPermissions); //compartir  groupPermissions
    const redirectPath = module.permissionLevel === 'admin' ? '/starter' : '/sales/projects-select';
    this.routes.navigate([redirectPath], { replaceUrl: true });
    this.modalService.dismissAll();
  }

  private decodeAccessToken(accessToken: string): any {
    try {
      return jwtDecode(accessToken);
    } catch (error) {
      this.notifier.notify('error', 'No fue posible leer la información del token.');
      throw error;
    }
  }

  private buildExecutiveInfo(executiveInfo: any, tokenClaims: any, fallbackUsername: string): any {
    const username = tokenClaims?.preferred_username || executiveInfo?.user_keycloak || fallbackUsername;
    const firstName = tokenClaims?.given_name || '';
    const lastName = tokenClaims?.family_name || '';
    const fullName = tokenClaims?.name || executiveInfo?.name || `${firstName} ${lastName}`.trim() || username;

    return {
      ...executiveInfo,
      id: executiveInfo?.id,
      sub: tokenClaims?.sub || '',
      keycloak_id: tokenClaims?.sub || '',
      sid: tokenClaims?.sid || '',
      user_keycloak: executiveInfo?.user_keycloak || username,
      username,
      preferred_username: username,
      first_name: executiveInfo?.first_name || firstName,
      last_name: executiveInfo?.last_name || lastName,
      name: fullName,
      full_name: fullName,
      email: tokenClaims?.email || executiveInfo?.email || '',
      email_verified: !!tokenClaims?.email_verified,
      scope: tokenClaims?.scope || ''
    };
  }


  private handleChannelProject(dataB: any): Observable<any> {

    ////console.log('dataB', dataB);
    return this._channelProjectService.getListChannelProject().pipe(
      tap((data) => {
        this.localStorage.setItem('channelProject', JSON.stringify(data[0]));
      }),
      map(() => dataB) // Retorna dataB para que el siguiente paso tenga acceso
    );
  }

  private handlePlanMembership(dni: any, executiveId: string): Observable<any> {
    const data = {
      executiveID: executiveId,
      dni: dni,
      channel: 'SAPO',
      is_active: true,
    };
    return this._planService.postPlanMenbershipCustomer(data);
  }

  private persistRememberCredentials(uname: string, p: string): void {
    if (this.recuerdame) {
      this.localStorage.setItem('recuerdame', true);
      this.localStorage.setItem('uname', uname);
      this.localStorage.setItem('p', p);
      return;
    }

    this.localStorage.setItem('recuerdame', false);
    this.localStorage.removeItem('uname');
    this.localStorage.removeItem('p');
  }

  private handlePlanMembershipResult(dataC: any): boolean {

    if (Object.keys(dataC).length !== 0) {
      this.persistCustomerMembershipContext(dataC);
      this.localStorage.setItem('products', JSON.stringify(dataC.products));
      this.localStorage.setItem('baseProducts', JSON.stringify(dataC.products));
      this.localStorage.setItem('accounts', JSON.stringify(dataC.accounts || []));
      return true;
    } else {
      this.notifier.notify('warning', 'Lo siento cliente no existe.');
      return false;
    }
  }

  private persistCustomerMembershipContext(data: any): void {
    const memberships = this.normalizeMemberships(data?.membership);
    const draftMembership = this.getDraftMembership(memberships);
    const activeMemberships = this.getActiveMemberships(memberships);
    const referenceMembership = draftMembership || activeMemberships[0] || memberships[0] || null;

    this.localStorage.setItem('allMembership', JSON.stringify(memberships));
    this.localStorage.setItem('draftMembership', JSON.stringify(draftMembership));
    this.localStorage.setItem('activeMemberships', JSON.stringify(activeMemberships));
    this.localStorage.setItem('dataMembership', JSON.stringify(referenceMembership));
    this.localStorage.setItem('membership', JSON.stringify(referenceMembership));
    this.localStorage.setItem('membershipSaveNewInfo', JSON.stringify(referenceMembership));
  }

  private normalizeMemberships(membership: any): any[] {
    if (Array.isArray(membership)) {
      return membership;
    }

    return membership ? [membership] : [];
  }

  private getDraftMembership(memberships: any[]): any {
    return memberships.find((membership) => !membership?.product_id && !membership?.plan_id) || null;
  }

  private getActiveMemberships(memberships: any[]): any[] {
    return memberships.filter((membership) => membership?.product_id || membership?.plan_id);
  }


  showRecoverForm() {
    this.loginform = !this.loginform;
    this.recoverform = !this.recoverform;
  }

  onCheckboxChange() {
    this.localStorage.setItem('recuerdame', JSON.stringify(!this.recuerdame));
  }

  check(uname: string, p: string) {
    this.loadDataUrl(uname, p, null, null);
  }


  closeBtnClick() {
    this.modalService.dismissAll();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
